"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.textBit = exports["default"] = exports.ctaPropType = exports.category = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var ctaPropType = _propTypes["default"].shape({
  url: _propTypes["default"].string,
  label: _propTypes["default"].string,
  priority: _propTypes["default"].string,
  icon: _propTypes["default"].string,
  openNewTab: _propTypes["default"].bool
});

exports.ctaPropType = ctaPropType;

var textBit = _propTypes["default"].shape({
  paragraph: _propTypes["default"].string,
  link: ctaPropType,
  anchorPoint: _propTypes["default"].string
});

exports.textBit = textBit;

var category = _propTypes["default"].shape({
  heading: _propTypes["default"].string,
  order: _propTypes["default"].number,
  textSection: textBit
});

exports.category = category;

var PROP_TYPES = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  categories: _propTypes["default"].arrayOf(category)
});

var _default = PROP_TYPES;
exports["default"] = _default;